// extracted by mini-css-extract-plugin
export default {"box":"TopRowExpandButton_box__AOWpt"};